<template>
  <div v-if="isVisible" class="loading-overlay">
    <div class="loading-container">
      <v-card class="loading-card pa-8" elevation="8" max-width="400">
      <div class="text-center">
        <!-- 動畫圖示 -->
        <v-progress-circular
          indeterminate
          :size="64"
          :width="6"
          color="primary"
          class="mb-4"
        />
        
        <!-- 標題 -->
        <h3 class="text-h5 font-weight-bold mb-2 text-primary">
          {{ title }}
        </h3>
        
        <!-- 描述 -->
        <p class="text-body-1 text-medium-emphasis mb-4">
          {{ description }}
        </p>
        
        <!-- 進度提示 -->
        <v-chip color="info" variant="tonal" size="small" class="mb-4">
          {{ progressText }}
        </v-chip>
        
        <!-- 額外提示 -->
        <div v-if="showTips" class="mt-4">
          <v-alert type="info" variant="tonal" density="compact" class="text-left">
            <div class="text-body-2">
              <v-icon icon="mdi-information" size="16" class="mr-2"></v-icon>
              <strong>請勿關閉此頁面</strong>
            </div>
            <div class="text-body-2 mt-1">
              分析完成後檔案將自動下載
            </div>
          </v-alert>
        </div>
      </div>
    </v-card>
    </div>
  </div>
</template>

<script>
import { computed } from 'vue'
import { loadingStore, hideLoading } from '@/store/loadingStore'

export default {
  name: 'LoadingOverlay',
  emits: ['cancel'],
  setup(props, { emit }) {
    const isVisible = computed(() => loadingStore.isVisible)
    const title = computed(() => loadingStore.title)
    const description = computed(() => loadingStore.description)
    const progressText = computed(() => loadingStore.progressText)
    const showTips = computed(() => loadingStore.showTips)

    function handleCancel() {
      emit('cancel')
      hideLoading()
    }

    return {
      isVisible,
      title,
      description,
      progressText,
      showTips,
      handleCancel
    }
  }
}
</script>

<style scoped>
.loading-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background: rgba(0, 0, 0, 0.5);
  backdrop-filter: blur(4px);
  z-index: 9999;
  display: flex;
  justify-content: center;
  align-items: center;
}

.loading-container {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 100%;
}

.loading-card {
  border-radius: 16px;
  background: rgba(255, 255, 255, 0.95);
  backdrop-filter: blur(10px);
  border: 1px solid rgba(255, 255, 255, 0.2);
  margin: 16px;
}

/* 動畫效果 */
.v-progress-circular {
  animation: pulse 2s ease-in-out infinite;
}

@keyframes pulse {
  0% {
    transform: scale(1);
  }
  50% {
    transform: scale(1.05);
  }
  100% {
    transform: scale(1);
  }
}

/* 響應式設計 */
@media (max-width: 600px) {
  .loading-card {
    margin: 16px;
    padding: 24px !important;
  }
  
  .loading-card h3 {
    font-size: 1.25rem !important;
  }
  
  .loading-card p {
    font-size: 0.875rem !important;
  }
}

/* 深色模式支援 */
.v-theme--dark .loading-card {
  background: rgba(30, 30, 30, 0.95);
  border: 1px solid rgba(255, 255, 255, 0.1);
}
</style>